import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from '@/components/icons';
import { ActiveContext } from '@/types';

interface MobileNavProps {
  activeContext: ActiveContext | null;
}

const roleColors: Record<string, string> = {
  admin: 'var(--sapBrandColor)',
  teacher: '#0a7b3c',
  student: '#7b4f0a',
  parent: '#6b3fa0',
};

export function MobileNav({ activeContext }: MobileNavProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const contextRole = activeContext?.role;

  const items = [
    { path: '/', icon: 'home' as const, label: t('navigation.home') },
    { path: '/products', icon: 'products' as const, label: t('navigation.products') },
    { path: '/notifications', icon: 'notifications' as const, label: t('navigation.notifications') },
  ];

  return (
    <nav className="mobile-nav" aria-label={t('common.menu')}>
      {items.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`mobile-navItem ${isActive ? 'mobile-navItem--active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon name={item.icon} size={22} aria-hidden="true" />
            <span>{item.label}</span>
          </Link>
        );
      })}
      {contextRole && (
        <div className="mobile-navBadge" aria-hidden="true" style={{ background: roleColors[contextRole.code] || 'var(--udexColorGrey6)' }}>
          {contextRole.name?.charAt(0) || '?'}
        </div>
      )}
    </nav>
  );
}
